import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/publishReplay';

@Injectable()
export class ConfigService {
    config: any = {};

    constructor(public http: Http) {
    }

    /**
     * Loads config file from file system
     * @returns {Observable<any>}
     */
    getConfigAsync(): Observable<any> {
        return this.http.get('./assets/data/config.json')
            .map((res) => res.json())
            .do(res => {
                this.config = res;
                localStorage.setItem('appconfig', JSON.stringify(res));
            });
    }

    /**
     * Returns cached config file
     * @returns {any}
     */
    getConfig() {
        return this.config;
    }
}



// WEBPACK FOOTER //
// ./src/providers/config.ts